import { render, staticRenderFns } from "./Concepts.vue?vue&type=template&id=2d6a9d39&scoped=true&"
import script from "./Concepts.vue?vue&type=script&lang=js&"
export * from "./Concepts.vue?vue&type=script&lang=js&"
import style0 from "./Concepts.vue?vue&type=style&index=0&id=2d6a9d39&lang=scss&scoped=true&"
import style1 from "./Concepts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a9d39",
  null
  
)

export default component.exports